// src/theme.js
// Tek kaynak tasarım token'ları.
//
// Marka mavisi logodan örneklendi (#0c84cc). Arayüz bugüne kadar bunun soluk bir
// türevini (#64b5f6) kullanıyordu; başlıklar ve butonlar bu yüzden zayıf kontrastlı
// görünüyordu. Renkler artık logonun kendisinden türetiliyor.
//
// Grafik renkleri dataviz doğrulayıcısından geçirildi (beyaz yüzeye karşı,
// --pairs all): yeşil↔turuncu deuteranopi ΔE 7.0 — bu banttaki bir palet YALNIZCA
// ikincil kodlamayla (ikon + doğrudan etiket + boşluk) kullanılabilir, grafiklerde
// üçü de var. Kırmızı/yeşil ikilisi ΔE 3.0 ile sert biçimde başarısızdı, o yüzden
// kırmızı yerine turuncu kullanılıyor.

import { createTheme } from '@mui/material/styles';

export const tokens = {
  brand: '#0c84cc',
  brandDeep: '#0a6ba6',
  brandInk: '#08405f',
  brandWash: '#e8f3fb',

  ink: '#12232e',
  inkMuted: '#5b6b77',
  inkFaint: '#8a99a4',

  canvas: '#eef4f8',
  surface: '#ffffff',
  line: '#d5e2ec',

  // Durum / grafik renkleri (doğrulanmış)
  success: '#15803d',
  partial: '#7e22ce',
  danger: '#c2410c',
  successWash: '#eaf5ee',
  dangerWash: '#fdeee7',
};

const fontStack = [
  '"Segoe UI"',
  'Inter',
  'system-ui',
  '-apple-system',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

export const theme = createTheme({
  palette: {
    primary: { main: tokens.brand, dark: tokens.brandDeep, contrastText: '#ffffff' },
    success: { main: tokens.success },
    error: { main: tokens.danger },
    background: { default: tokens.canvas, paper: tokens.surface },
    text: { primary: tokens.ink, secondary: tokens.inkMuted },
    divider: tokens.line,
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: fontStack,
    // Ölçek: başlıklarda sıkı harf aralığı, gövdede rahat satır yüksekliği.
    h4: { fontWeight: 700, letterSpacing: '-0.02em', fontSize: '1.75rem' },
    h5: { fontWeight: 700, letterSpacing: '-0.015em', fontSize: '1.35rem' },
    h6: { fontWeight: 700, letterSpacing: '-0.01em', fontSize: '1.1rem' },
    subtitle2: { fontWeight: 600, letterSpacing: '0.01em' },
    body1: { lineHeight: 1.6 },
    body2: { lineHeight: 1.6 },
    button: { fontWeight: 600, letterSpacing: '0.02em', textTransform: 'none' },
    overline: { fontWeight: 700, letterSpacing: '0.12em', fontSize: '0.68rem' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { paddingTop: 10, paddingBottom: 10, boxShadow: 'none' },
        containedPrimary: {
          '&:hover': { backgroundColor: tokens.brandDeep, boxShadow: 'none' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: `1px solid ${tokens.line}`,
          boxShadow: '0 1px 2px rgba(18,35,46,0.04), 0 8px 24px -16px rgba(18,35,46,0.25)',
        },
      },
    },
    MuiTextField: { defaultProps: { variant: 'outlined' } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: tokens.brand },
        },
      },
    },
  },
});

export default theme;
